import React from 'react';
import { useAppSelector } from '../../../../../../hooks/hooks';
import Box from '@mui/material/Box';
import {FilterState } from './types';
import CostFilterListPopup from '../property-filter-popup';
import { REmployees } from '../../../../../../features/roles/types';

interface Props {
    onChange: (state: FilterState) => Promise<void>;
    disabled?: boolean;
    employees?: REmployees[];
    disableEmployeesFilter?: boolean;
}

const CostReportFilter = (props: Props) => {
    const employees = useAppSelector((selector) => selector.rEmployees);
    const filterEmployees = props.employees ?? employees;

    return (
        <Box display={'flex'} gap={2} height={'100%'} alignItems={'center'}>
            <CostFilterListPopup
                employees={filterEmployees}
                onChange={props.onChange}
                disabled={props.disabled}
                disableEmployeesFilter={props.disableEmployeesFilter}
            />
        </Box>
    )
};

export default React.memo(CostReportFilter);
